const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const messagingService = {
  // Send message
  async sendMessage(senderId, receiverId, listingId, messageContent) {
    try {
      const body = {
        SenderId: parseInt(senderId),
        ReceiverId: parseInt(receiverId),
        MessageContent: messageContent
      };
      
      // Only include ListingId if it's provided and valid
      if (listingId && !isNaN(parseInt(listingId))) {
        body.ListingId = parseInt(listingId);
      }
      
      const response = await fetch(`${API_BASE_URL}/messaging/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!response.ok) {
        const error = await response.text();
        console.error('API Error:', error);
        throw new Error(`Send failed: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error sending message:', error);
      throw error;
    }
  },

  // Get seller messages
  async getSellerMessages(sellerId) {
    try {
      const response = await fetch(`${API_BASE_URL}/messaging/seller/${sellerId}`);
      if (!response.ok) throw new Error('Failed to fetch messages');
      const data = await response.json();
      // Handle both array and object with $values property (from .NET)
      return Array.isArray(data) ? data : (data?.$values || []);
    } catch (error) {
      console.error('Error fetching seller messages:', error);
      throw error;
    }
  },

  // Get chat between buyer and seller
  async getBuyerSellerChat(buyerId, sellerId) {
    try {
      const response = await fetch(`${API_BASE_URL}/messaging/chat/${buyerId}/${sellerId}`);
      if (!response.ok) throw new Error('Failed to fetch chat');
      const data = await response.json();
      // Handle both array and object with $values property (from .NET)
      return Array.isArray(data) ? data : (data?.$values || []);
    } catch (error) {
      console.error('Error fetching chat:', error);
      throw error;
    }
  },

  // Get sellers contacted by buyer
  async getBuyerSellers(buyerId) {
    try {
      const response = await fetch(`${API_BASE_URL}/messaging/buyer/${buyerId}/sellers`);
      if (!response.ok) throw new Error('Failed to fetch sellers');
      const data = await response.json();
      // Handle both array and object with $values property (from .NET)
      return Array.isArray(data) ? data : (data?.$values || []);
    } catch (error) {
      console.error('Error fetching sellers:', error);
      throw error;
    }
  }
};
